// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"411":"4ad7557d","486":"88aff9bf","574":"f714cd8f","582":"b0827910"}[chunkId] + ".css";
};